import React, { useState, useContext, useRef, useEffect }  from "react"; 
import webRootContext from "../components/webrootcontext/WebRootContext";
import {AppConfiguration} from "../framework/AppConfigProvider";
import {REGISTER_USER_ACCOUNT_OBJECT} from '../components/RegisterUserAccountObject';
import Ribbon from "../framework/Ribbon";
import InputTxt from "../framework/InputTxt";
import Dropdown from "../framework/DropdownObj";
import Button from "../framework/Button";
import {Formik} from "formik";
import ReCAPTCHA from "react-google-recaptcha";
import {SECURITY_QUESTION_OPTION_LIST} from '../components/SecurityQuestions';
import {COUNTRIES_LIST} from '../components/Countries';
 
function RegisterUserAccount(props) {
	const localConfig = useContext(AppConfiguration);	
	const [registerUserAccountFormObject, setRegisterUserAccountFormObject] = useState(REGISTER_USER_ACCOUNT_OBJECT);
	const [otherCountrySelected, setOtherCountrySelected] = useState(false);
	const [securityQst1Selected, setSecurityQst1Selected] = useState(false);
	const [securityQst2Selected, setSecurityQst2Selected] = useState(false);
	const [securityQst3Selected, setSecurityQst3Selected] = useState(false);
 	
	const [formikError, setFormikError] = useState(false);
	const [saveFailed, setSaveFailed] = useState(false);
	const [saveSuccess, setSaveSuccess] = useState(false);
    const [responseError, setResponseError] = useState("");
	const [formSubmitted, setFormSubmitted] = useState(false);
	const captchaRef = useRef(null);
 	
	function validateEmail(checkemail){
		let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,6}))$/; // eslint-disable-line
		//let reg = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
		return reg.test(checkemail.trim());
	}
	
	function validatePassword(checkPassword) {
	 // let reg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
		let reg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%&*?])[A-Za-z\d!@#$%&*?]{8,}$/;
		return reg.test(checkPassword);
	}	
	
	//---------------Start recaptcha.net --------------------------//
	window.recaptchaOptions = {
	  useRecaptchaNet: true	  
	};
	
	let captchaContent=<div></div>;
	if(localConfig.configProperties.captchaSiteKey!=null){
	  captchaContent = <ReCAPTCHA sitekey={localConfig.configProperties.captchaSiteKey}  ref={captchaRef}  />		
	}	
    	
	const verifyRecaptcha_api_url =  webRootContext + "/rest/captchaservice/verifyCaptcha";
	// -------------------------end recaptcha.net --------------------------//
    
    // construct a message for Password Help
    const validatePasswordMsg = <div>
	<ul>
	  <li>At least 8 characters long</li>
	  <li>Contains at least one letter (uppercase or lowercase)</li>
	  <li>Contains at least one digit</li>
	  <li>Contains at least one special character from the set !@#$%&*?</li>
	</ul> </div>;
   	
   	const successMsgSubheader =  <div>Thank you for registering to the Boston Children’s Hospital Observership Program portal.</div >
	const successMsgContent = <div>
		<div className="padding-bottom-30">An email has been sent to your email account. <span class="page_description">Please activate your account by clicking the link provided in the email.</span></div>
		<div className="padding-bottom-30">Please add the Observership Program email address (observership.program@childrens.harvard.edu) to your safe sender list to make sure you receive program communications.</div>
		<div className="padding-bottom-30">If you have not received an email with an activation code, please contact observership.program@childrens.harvard.edu.</div>
	</div>;
	
	function returnToLogin(){
		window.location.href = webRootContext + "/Login";
	}
	
	function VerifyToken(token, values){
	   
	   let url = verifyRecaptcha_api_url;
	   
	   if(token == null || token === "" )	{
	   	setSaveSuccess(false);
		setResponseError("Please check Captcha checkbox ");
	    setSaveFailed(true);		    		
		return;
	   }   
	   	   
	   fetch(url, {
	      	method: 'POST', 
	   		headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
					},
			body: token,
	    	mode:"cors"})
 		    .then((response) => {
				 return response.status;			  
		  })
		  .then((result) => {
			    if(result === 200){
				  SaveRegisteredUser(values);
			  } else {
				setSaveSuccess(false);
				setResponseError("verify token failed");
		    	setSaveFailed(true);
			  }
		  });
    }

	function SaveRegisteredUser(values){
		let url = webRootContext + "/rest/usermanagement/saveRegisteredUser";
		let  resetForm  = false;
		fetch(url, {
	      	method: 'POST', 
	   		headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
					},
			body: JSON.stringify(registerUserAccountFormObject), mode:"cors"})
 		 	.then((response) => {
			  if(response.ok){
					// Clear the form and display the success message.
				    resetForm  = true;
				    setRegisterUserAccountFormObject(REGISTER_USER_ACCOUNT_OBJECT); 
					setSaveSuccess(true);
		    		setSaveFailed(false);
		    	
			   } else {
				   let err =  response.headers.get("ERROR");  
				    resetForm  = false;
					setSaveSuccess(false);
		    		setSaveFailed(true);
		    		// setResponseError("There is an error while saving the user");
		    		setResponseError(err);
			   }
			   return response.json();
		})
		.then(
	        (result) =>   { 
	            if (resetForm) {      
	                setRegisterUserAccountFormObject(REGISTER_USER_ACCOUNT_OBJECT);          
	             } else {		 
					setRegisterUserAccountFormObject(registerUserAccountFormObject);
				 }
        })
 		.catch((err) => {
          	
	  	});  	
	}
	
    
    useEffect(() => {
    
        const footerElement = document.querySelector('.footer');
        if (footerElement) {
            footerElement.parentElement.classList.add("force_bottom")
        }
        
        return () => {
          if (footerElement) {
            footerElement.parentElement.classList.remove('force_bottom');
          }
        }
    
    },[]);
	
	return (
		<div id="registeruseraccount">
			<Formik 
		 	initialValues={{
		   	   firstName: "",
			   lastName: "",
			   email: "",
			   conEmail: "",
			   password: "",
			   conPassword: "",
			   country: "",		  
			   securityQst1: "",
			   securityAns1: "",
			   securityQst2: "",
			   securityAns2: "",
			   securityQst3: "",
			   securityAns3: ""				    
			 }}
			 
			validate={values => {
	         	const errors = {};
	         	//added to hide server error banner in case it's already displaying from a previous (unsuccessful) attempt at submission 
	         	setSaveFailed(false); 
	         	
         		if (registerUserAccountFormObject) {
		             
			        if (!values.firstName || values.firstName.trim() === "") {
			        	errors.firstName = 'First name is required';
			        }  
			         
			        if (!values.lastName || values.lastName.trim() === "") {
			            errors.lastName = 'Last name is required';
			        }  
			         
			       
			        
			        let emailErrorMsg = 'Enter a valid email address using this format: example@mail.com';	         
			        if (!values.email.trim()) {
			            errors.email = 'Email address is required';
			        } else if ((values.email) && (!validateEmail(values.email))) {
						errors.email = emailErrorMsg;  
					}
			         
			        if (!values.conEmail.trim()) {
						errors.conEmail = 'Retype email address is required';  
					} else if (values.conEmail !== values.email) {
			           errors.conEmail = 'Email address must match';
			        } else if ((values.conEmail) && (!validateEmail(values.conEmail))) {
						errors.conEmail = emailErrorMsg;  
					} 
			         
			        let passwordErrorMsg = 'Enter a password that meets above criteria';		        
			        if (!values.password) {
			           errors.password = 'Password is required';
			        } else if ((values.password) && (!validatePassword(values.password))) {   
			           errors.password = passwordErrorMsg;
			        } 
					 
					if (!values.conPassword) {
			           errors.conPassword = 'Retype password is required';			       
			        } else if (values.conPassword !== values.password) {
			           errors.conPassword = 'Passwords must match';
			        }
			        
			        if(!values.country || values.country === null || values.country.trim().length === 0){
						errors.country = 'Country/Region of residence is required';
					}else if (values.country.length > 50){
						errors.country = 'The max length for Country/Region of residence is 50 characters long';
					}
					
					if(otherCountrySelected){ 
						if (!values.otherCountry || values.otherCountry === null || values.otherCountry.trim() === "") {
			            	errors.otherCountry = 'Other country/region is required';
				        }
				        
				        else if(values.otherCountry.length < 2 || values.otherCountry.length > 50) {
							errors.otherCountry = "Enter a country/region that is 2 to 50 characters long"; 
						}
					}
					 
					
			      	
			      	   
		            if (!values.securityQst1 || values.securityQst1 === null || values.securityQst1.length < 2) {
			            errors.securityQst1 = 'Security Question 1 is required';
			        } else if (values.securityQst1 === values.securityQst2 || values.securityQst1 === values.securityQst3) {
			           errors.securityQst1 = 'You have already selected this security question. Please choose a different one';
			        } 
			        
			        if (!values.securityAns1 || values.securityAns1.trim() === "") {
			            errors.securityAns1 = 'Security Answer 1 is required';
			        }
			        
			        else if(values.securityAns1.length < 2 || values.securityAns1.length > 100) {
						errors.securityAns1 = "Enter a security answer that is 2 to 100 characters long"; 
					}
			        
			        if (!values.securityQst2 || values.securityQst2 === null || values.securityQst2.length < 2) {
			            errors.securityQst2 = 'Security Question 2 is required';
			        } else if (values.securityQst2 === values.securityQst1 || values.securityQst2 === values.securityQst3) {
			           errors.securityQst2 = 'You have already selected this security question. Please choose a different one';
			        } 
			        
			        if (!values.securityAns2 || values.securityAns2.trim() === "" ) {
			            errors.securityAns2 = 'Security Answer 2 is required';
			        }
			        
			        else if(values.securityAns2.length < 2 || values.securityAns2.length > 100) {
						errors.securityAns2 = "Enter a security answer that is 2 to 100 characters long"; 
					}	        
			        
			        if ( !values.securityQst3 || values.securityQst3 === null || values.securityQst3.length < 2) {
			            errors.securityQst3 = 'Security Question 3 is required';
			        } else if (values.securityQst3 === values.securityQst1 || values.securityQst3 === values.securityQst2) {
			           errors.securityQst3 = 'You have already selected this security question. Please choose a different one';
			        } 	        
			        
			        if (!values.securityAns3 || values.securityAns3.trim() === "") {
			            errors.securityAns3 = 'Security Answer 3 is required';
			        }
			        
			        else if(values.securityAns3.length < 2 || values.securityAns3.length > 100) {
						errors.securityAns3 = "Enter a security answer that is 2 to 100 characters long"; 
					}  
		        }  
				
				
				
				// If there are any formik errors, set a flag to true in order to trigger the display of the error ribbon.
		        if( Object.keys(errors).length > 0) {
					setFormikError(true);
				} else {
		        	setFormikError(false);
		        }	
          
		        return errors;
		    }}
		      		    		    
		    onSubmit={(values, { setSubmitting, resetForm }) => {
		          setTimeout(() => {
					  	const token = captchaRef.current.getValue();
					  	captchaRef.current.reset();					  	
					  	VerifyToken(token, values);					  	
		          		setSubmitting(false);
		            	// resetForm(); // we should not reset here because If a validation fails, it resets the entire form.
		          }, 1);
		        }} 
			>  
			{({
				values /* all data need to run the valdation*/,
				errors /* all error strings */,
				touched /* all field touch event  */,
  				handleChange /* value change event handler */,
  				handleBlur /* onBlur event handler */,
  				handleSubmit /* for submit button */,
  				isSubmitting /* for submit button */,
  				isValid /* for submit button */,
  				dirty /* for submit button */,
  				validateForm
				  /* and other goodies */
				}) => (
				<form onSubmit={handleSubmit} noValidate>
					<div id="submitSuccess" className={(saveSuccess ? 'show_div' : 'hide_div')}>
						<div id="successDiv" className="div_3_col">
							<Ribbon label={"Submitted"} status={"checkmark"} subheader={successMsgSubheader} content={successMsgContent} />
						</div>
				   </div>
				   
				   <div id="submitFailed" className={(saveFailed ? 'show_div' : 'hide_div')}>
						<div id="failDiv" className="div_1_col">
							<Ribbon label={"ERROR"} status={"error"} subheader={""} content={responseError} />
						</div>
				   </div>
				   
				   <div id="formikErrors" className={(formikError && formSubmitted? 'show_div' : 'hide_div')}>
		               <div id="formikFailDiv" className="div_1_col">
		               		<Ribbon label={"REVIEW ISSUES BELOW"} status={"error"} subheader={""} content={""} />
		               </div>
		          </div>
			 			 		  	
				  <div id="formInputs" className={(saveSuccess ? 'hide_div' : 'show_div' )} >
				  	<div className="div_3_col"> 
						<div className="breadcrumbLink"><a href="##" onClick={(e) => {returnToLogin();}}>Login</a></div> 
						<div className="page_title">Create Account</div>
						<br/>
						<div className="horizontal_div">
			   				<div>				 	
				            	<InputTxt
					                id="firstName" 
					                name="firstName" 
					                labelText="First name"
					                helpMessage = ""
					                isRequired={true}  
					                maxLength={50}   
					                errorMessage={errors.firstName}         
					                hasError={touched.firstName && errors.firstName}                               
					                onChange={handleChange}
					                onBlur={handleBlur} 
					                value={registerUserAccountFormObject.firstName}     
					                getTextString={(firstName) =>setRegisterUserAccountFormObject({...registerUserAccountFormObject, firstName: firstName.trim()})}                                     
				                />
					        </div>
					        
					        <div>				              
					            <InputTxt
					                id="lastName" 
					                name="lastName" 
					                labelText="Last name"
					                helpMessage = ""
					                isRequired={true}
					                maxLength={50}     
					                errorMessage={errors.lastName}         
					                hasError={touched.lastName && errors.lastName}                               
					                onChange={handleChange}
					                onBlur={handleBlur}
					                value={registerUserAccountFormObject.lastName}     
					                getTextString={(lastName) =>setRegisterUserAccountFormObject({...registerUserAccountFormObject, lastName: lastName.trim()})}				                           
				                />
			              	</div>
					 	</div>
					</div>
					
					<div className="div_3_col">	 
					 	<div className="horizontal_div">
	           				<div>				 	
					            <InputTxt
					            	id="email" 
					                name="email" 
					                labelText="Email address"
					                helpMessage = {"This will be your username to log in"}
					                isRequired={true}  
					                maxLength={100}   
					                errorMessage={errors.email}         
					                hasError={touched.email && errors.email}                               
					                onChange={handleChange}
					                onBlur={handleBlur}
					                value={registerUserAccountFormObject.email.trim()}     
					                getTextString={(email) =>setRegisterUserAccountFormObject({...registerUserAccountFormObject, email: email.trim()})}              
					              />
					        </div>
					        
					        <div>				              
					              <InputTxt
					                id="conEmail" 
					                name="conEmail" 
					                labelText="Retype email address"
					                helpMessage = ""
					                isRequired={true} 
					                maxLength={100}       
					                errorMessage={errors.conEmail}         
					                hasError={touched.conEmail && errors.conEmail}                               
					                onChange={handleChange}
					                onBlur={handleBlur}   
					                value={registerUserAccountFormObject.conEmail.trim()}  
					                getTextString={(conEmail) =>setRegisterUserAccountFormObject({...registerUserAccountFormObject, conEmail: conEmail.trim()})}              
					              />
			              	</div>
					 	</div>
					</div>
					
					<div className="div_3_col">	 
					 	<div className="horizontal_div">				 	
	           				<div>	
	           					<InputTxt
					                id="password" // need match value name
					                name="password" // name will not work for formik in this case for input box
					                labelText="Password"					           
					                isRequired={true} 
					                maxLength={150}                
					                type="password"
					                // show error and error message is control by formik    
					                errorMessage={errors.password}      
					                hasError={touched.password && errors.password}  
					                helpMessage = {validatePasswordMsg}             
					                // onchange and onblur is return event, handle by formik
					                onChange={handleChange}
					                onBlur={handleBlur}
					                value={registerUserAccountFormObject.password}
					                getTextString={(password) =>setRegisterUserAccountFormObject({...registerUserAccountFormObject, password: password})}
					              />	           					
					        </div>
					        
					        <div>				              
					              <InputTxt
					                id="conPassword" 
					                name="conPassword" 
					                labelText="Retype password"
					                helpMessage = ""
					                isRequired={true}
					                maxLength={150}	
					               	type="password"					          
					                // show error and error message is control by formik					                    
					                errorMessage={errors.conPassword} 	 
					                hasError={touched.conPassword && errors.conPassword}                              
					                onChange={handleChange}
					                onBlur={handleBlur}
					                value={registerUserAccountFormObject.conPassword}     
					                getTextString={(conPassword) =>setRegisterUserAccountFormObject({...registerUserAccountFormObject, conPassword: conPassword})}              
					              />
			              	</div>
					 	</div>
					</div>
					
					<div className="div_3_col">			 	 	
			 	 		<Dropdown
			                data={COUNTRIES_LIST}
			                label="Country/Region of residence"
			                isRequired={true}
			                helpMessage=""
			                isDisabled={false}
			                name="country" 
			                id="country"		                 
			                selectedItem={values.country}
							disableDefault={false}
			                getSelectedValue={(country) => {setRegisterUserAccountFormObject({...registerUserAccountFormObject, country: country.value});}}
			                errorMessage={errors.country}
			                hasError={touched.country && errors.country}		                
			                onChange={(country) => {	
							  errors.country = "";	
							  setOtherCountrySelected(false);	
							  values.otherCountry = null; 							
			                  if (country) {
			                  	values.country = country.value;							  	
							  	if(country.value==="Other"){
									  setOtherCountrySelected(true);	
									  setRegisterUserAccountFormObject({...registerUserAccountFormObject, country: ""});
								 }else{
									 setRegisterUserAccountFormObject({...registerUserAccountFormObject, country: country.value});
								 }
			                    
							  } else {
								  values.country = null
								  setRegisterUserAccountFormObject({...registerUserAccountFormObject, country: null});
							  }
							  		                  
			                }}			               
			                onBlur={(e) => {
								handleBlur(e);
							}}
			                value={(country) => {
			                	values.country = country.value;
			                }}			                			                
			            />			 	 				 	 						 	 						 	 		 	 	
		         	</div>	
		         	<div className="div_3_col">
		         	     <div className={(otherCountrySelected ? 'show_div' : 'hide_div')}>
                        
                        	<InputTxt
				            	id="otherCountry" 
				                name="otherCountry" 
				                labelText="Other country/region"
				                helpMessage = ""
				                isRequired={otherCountrySelected? true: false} 
				                maxLength={50}    
				                errorMessage={errors.otherCountry}         
				                hasError={touched.otherCountry && errors.otherCountry}                               
				                onChange={handleChange}
				                onBlur={handleBlur} 
				                value={values.otherCountry}     
				                getTextString={(otherCountry) =>setRegisterUserAccountFormObject({...registerUserAccountFormObject, country: otherCountry})}                  
				        	/>	
                        </div> 
		         	</div>         	
		         	<div className="div_3_col">		             
		            	<Dropdown
			                data={SECURITY_QUESTION_OPTION_LIST}
			                label="Security question 1"
			                isRequired={true}
			                helpMessage=""
			                isDisabled={false}
			                name="securityQst1" 
			                id="securityQst1"		                 
			                selectedItem={values.securityQst1}
							disableDefault={false}
			                getSelectedValue={(selectedQuestion1) => {setRegisterUserAccountFormObject({...registerUserAccountFormObject, securityQst1: selectedQuestion1.value});}}
			                // show error and error message is control by formik
			                errorMessage={errors.securityQst1}
			                hasError={touched.securityQst1 && errors.securityQst1}
			                // return event to formik			                
			                onChange={(securityQst1) => {	
							  errors.securityQst1 = "";		  								
			                  if (securityQst1) {
			                  	values.securityQst1 = securityQst1.value;	
							  	setRegisterUserAccountFormObject({...registerUserAccountFormObject, securityQst1: securityQst1.value});
			                    setSecurityQst1Selected(true);
			                    
							  } else {
								  values.securityQst1 = null
								  setRegisterUserAccountFormObject({...registerUserAccountFormObject, securityQst1: null});
							  	setSecurityQst1Selected(false);
							  }
							  
							  //if previous answer entered, clear it out
							  if(values.securityAns1 !== null)
							  {
								  values.securityAns1 = null
								  setRegisterUserAccountFormObject({...registerUserAccountFormObject, securityAns1: null});
							  }			                  
			                }}			               
			                onBlur={(e) => handleBlur(e)}
			                // update formik value
			                value={(selectedQuestion1) => {
			                	values.securityQst1 = selectedQuestion1.value;
			                }}			                			                
			            />
		            </div>
		         	
		         	<div className="div_3_col">		         	
		         		<div className={(securityQst1Selected ? 'show_div' : 'hide_div')}>
                        
                        	<InputTxt
				            	id="securityAns1" 
				                name="securityAns1" 
				                labelText="Security answer 1"
				                helpMessage = ""
				                isRequired={true} 
				                maxLength={100}    
				                errorMessage={errors.securityAns1}         
				                hasError={touched.securityAns1 && errors.securityAns1}                               
				                onChange={handleChange}
				                onBlur={handleBlur} 
				                value={registerUserAccountFormObject.securityAns1}     
				                getTextString={(securityAns1) =>setRegisterUserAccountFormObject({...registerUserAccountFormObject, securityAns1: securityAns1})}                  
				        	/>	
                        </div> 
			        </div>
		         	 
		          	<div className="div_3_col">	
		          		                    
		            	<Dropdown
			                data={SECURITY_QUESTION_OPTION_LIST}
			                label="Security question 2"
			                isRequired={true}
			                helpMessage=""
			                isDisabled={false}
			                name="securityQst2" 
			                id="securityQst2"
			                selectedItem={registerUserAccountFormObject.securityQst2}
							disableDefault={false}
			                getSelectedValue={(selectedQuestion2) => {setRegisterUserAccountFormObject({...registerUserAccountFormObject, securityQst2: selectedQuestion2.value});}}
			                // show error and error message is control by formik
			                errorMessage={errors.securityQst2}
			                hasError={touched.securityQst2 && errors.securityQst2}
			                // return event to formik
			                onChange={(securityQst2) => {
								errors.securityQst2 = "";
			                  if (securityQst2) {
			                  	values.securityQst2 = securityQst2.value;
								setRegisterUserAccountFormObject({...registerUserAccountFormObject, securityQst2: securityQst2.value});	
			                    setSecurityQst2Selected(true);
							  } else {
								values.securityQst2 = null
								setRegisterUserAccountFormObject({...registerUserAccountFormObject, securityQst2: null});
							  	setSecurityQst2Selected(false);
							  }	
							  
							  //if previous answer entered, clear it out
							  if(values.securityAns2 !== null)
							  {
								  values.securityAns2 = null
								  setRegisterUserAccountFormObject({...registerUserAccountFormObject, securityAns2: null});
							  }		                  
			                }}
			                onBlur={(e) => handleBlur(e)}
			                // update formik value
			                value={(selectedQuestion2) => {
			                  values.securityQst2 = selectedQuestion2;
			                }}
			            />
		            </div>
		         	
		         	<div className="div_3_col">					
		         		<div className={(securityQst2Selected ? 'show_div' : 'hide_div')}>                        
                        	<InputTxt
				            	id="securityAns2" 
				                name="securityAns2" 
				                labelText="Security answer 2"
				                helpMessage = ""
				                isRequired={true} 
				                maxLength={100}        
				                errorMessage={errors.securityAns2}         
				                hasError={touched.securityAns2 && errors.securityAns2}                               
				                onChange={handleChange}
				                onBlur={handleBlur}
				                value={registerUserAccountFormObject.securityAns2}       
				                getTextString={(securityAns2) =>setRegisterUserAccountFormObject({...registerUserAccountFormObject, securityAns2: securityAns2})}                  
				        	/>	
                        </div> 
			        </div>
		         	
		         	<div className="div_3_col">			             
		            	<Dropdown
			                data={SECURITY_QUESTION_OPTION_LIST}
			                label="Security question 3"
			                isRequired={true}
			                helpMessage=""
			                isDisabled={false}
			                name="securityQst3" 
			                id="securityQst3" 
			                selectedItem={registerUserAccountFormObject.securityQst3}
							disableDefault={false}
			                getSelectedValue={(selectedQuestion3) => {setRegisterUserAccountFormObject({...registerUserAccountFormObject, securityQst3: selectedQuestion3.value});}}
			                // show error and error message is control by formik
			                errorMessage={errors.securityQst3}
			                hasError={touched.securityQst3 && errors.securityQst3}
			                // return event to formik
			                onChange={(securityQst3) => {
								errors.securityQst2 = "";
			                  if (securityQst3) {
			                  	values.securityQst3 = securityQst3.value;
								setRegisterUserAccountFormObject({...registerUserAccountFormObject, securityQst3: securityQst3.value});	
			                	setSecurityQst3Selected(true);
							  } else {
								values.securityQst3 = null;
								setRegisterUserAccountFormObject({...registerUserAccountFormObject, securityQst3: null});	 	
							  	setSecurityQst3Selected(false);
							  }
							  
							  //if previous answer entered, clear it out
							  if(values.securityAns3 !== null)
							  {
								  values.securityAns3 = null
								  setRegisterUserAccountFormObject({...registerUserAccountFormObject, securityAns3: null});
							  }				                  
			                }}
			                onBlur={(e) => handleBlur(e)}
			                // update formik value
			                value={(selectedQuestion3) => {
			                  values.securityQst3 = selectedQuestion3;
			                }}		               
			            />
		            </div>		         	
		         	
		         	<div className="div_3_col">
		         		<div className={(securityQst3Selected ? 'show_div' : 'hide_div')}>
                        
                        	<InputTxt
				            	id="securityAns3" 
				                name="securityAns3" 
				                labelText="Security answer 3"
				                helpMessage = ""
				                isRequired={true}
				                maxLength={100}         
				                errorMessage={errors.securityAns3}         
				                hasError={touched.securityAns3 && errors.securityAns3}                               
				                onChange={handleChange}
				                onBlur={handleBlur} 
				                value={registerUserAccountFormObject.securityAns3}  				             
				                getTextString={(securityAns3) =>setRegisterUserAccountFormObject({...registerUserAccountFormObject, securityAns3: securityAns3})}                  
				        	/>	
                        </div> 
			        </div>
		         	
		         	<hr className="hr--light" />
		         	 
		            <div className="div_3_col padding-bottom-30">
		              {captchaContent}
		            </div>
		         	
		            <div className="div_3_col horizontal_div">
		              <Button
		                text={"CREATE ACCOUNT"}
		                styleName={"button button--primary"}
		                id={"button_submit"}
		                type="submit"
		                onClick={(e) =>{setFormSubmitted(true); validateForm();window.scrollTo({top: 0, left: 0, behavior: 'auto'});}}
		              />
		                            
		            </div>
		         	  
				  </div>
				 			             			 	
		        </form>
				 			 
				)}
		 	</Formik>				 
	    </div> 
	 )
 }
  
 export default RegisterUserAccount;